import axios from "axios";
import { useEffect, useState } from "react";
import NavBar from "../NavBar";
import LoginPage from "./LoginPage";
import { useLocation } from "react-router-dom";


function VerifyApplicant() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const [status, setStatus] = useState("idle");

    useEffect(() => {
        if (!token) {
            setStatus("missing-token");
            return;
        }

        axios
            .get(`${process.env.REACT_APP_API_URL}/partner/public/verificationtoken/validate/${token}`)
            .then((res) => {
                if (res.status === 200) {
                    setStatus("success");
                } else {
                    setStatus("error");
                }
            })
            .catch(() => {
                setStatus("error");
            });
    }, [token]);

    if (status === "missing-token") {
        return (
            <div>
                <NavBar />
                <h1>Verification link is missing a token.</h1>
            </div>
        );
    }

    if (status === "error") {
        return (
            <div>
                <NavBar />
                <h1>We could not verify your email. Please request a new verification link.</h1>
            </div>
        );
    }

    if (status === "success") {
        return (
            <div>
                <NavBar />
                <h1>Thank you for verifying your email address. Log in with your email and password to complete your application.</h1>
                <LoginPage />
            </div>
        );
    }

    return (
        <div>
            <NavBar />
            <h1>Verifying your email...</h1>
        </div>
    );
}

export default VerifyApplicant;